import React, { useState, useRef } from "react";
import axios from "axios";
import { Upload } from "lucide-react";
import { API, BACKEND_URL } from "@/config";

const ImageUploader = ({ value, onChange, token, label = "Photo" }) => {
  const [uploading, setUploading] = useState(false);
  const fileRef = useRef(null);

  const handleUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    if (!file.type.startsWith('image/')) {
      alert('Please select an image file (JPG, PNG, etc.)');
      return;
    }
    if (file.size > 5 * 1024 * 1024) {
      alert('Image must be under 5MB');
      return;
    }

    setUploading(true);
    try {
      const formData = new FormData();
      formData.append('file', file);
      const res = await axios.post(`${API}/admin/upload`, formData, {
        headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'multipart/form-data' }
      });
      onChange(`${BACKEND_URL}${res.data.url}`);
    } catch (err) {
      alert('Upload failed: ' + (err.response?.data?.detail || err.message));
    } finally {
      setUploading(false);
      if (fileRef.current) fileRef.current.value = '';
    }
  };

  return (
    <div className="form-group">
      <label className="form-label">{label}</label>
      <div className="image-upload-row">
        {value && (
          <img 
            src={value} 
            alt="Preview" 
            className="image-upload-preview"
          />
        )}
        <div className="image-upload-controls">
          <button
            type="button"
            className="btn btn-secondary btn-sm"
            onClick={() => fileRef.current?.click()}
            disabled={uploading}
            data-testid="image-upload-btn"
          >
            {uploading ? (
              <><span className="loading-spinner-sm"></span> Uploading...</>
            ) : (
              <><Upload size={14} /> Upload Image</>
            )}
          </button>
          <input
            ref={fileRef}
            type="file"
            accept="image/*"
            onChange={handleUpload}
            style={{ display: 'none' }}
          />
          <input
            type="text"
            className="form-input"
            value={value || ''}
            onChange={(e) => onChange(e.target.value)}
            placeholder="Or paste image URL"
            style={{ fontSize: '0.8rem' }}
          />
        </div>
      </div>
    </div>
  );
};

export default ImageUploader;
